/* Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. */

import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, CanDeactivateFn, RouterStateSnapshot } from '@angular/router';
import { GranularEnabledService } from '../../common/granular-time/granular-enabled.service';

/**
 * Sync `:projectId` from the route (or ancestor) to `GranularEnabledService`.
 * Always returns `true`. Use on routes with `:projectId`, placed before guards that depend on it.
 * Should be used `clearProjectContextGuard`.
 */
export const projectContextGuard: CanActivateFn = (route) => {
	const granular = inject(GranularEnabledService);
	const projectId =
		route.pathFromRoot.find((s) => s.paramMap.has('projectId'))?.paramMap.get('projectId') ?? null;
	if (projectId) {
		granular.setProjectId(projectId);
	}
	return true;
};

/**
 * Clear the current project context when navigating away from a project route.
 * Should be used with `projectContextGuard`.
 */
export const clearProjectContextGuard: CanDeactivateFn<unknown> = () => {
	inject(GranularEnabledService).clearProjectId();
	return true;
};
